import {setResize} from './set-resize';

export const resize = (): void => {
  let resizeTimeout: NodeJS.Timeout;
  const observer = new ResizeObserver(() => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      setResize();
    }, 2000);
  });

  observer.observe(document.body);
  window.addEventListener('orientationchange', () => {
    setResize();
  });
};
